import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: ${(props) => (props.compact ? '4px 10px' : '6px 10px 8px')};
`;

// Hint inline pro estado vazio (compact mode) — texto pequeno ao lado
// do label "Eventos" em vez do strip vazio gigante.
export const EmptyHintInline = styled.span`
  font-size: 10px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.label};
  opacity: 0.7;
  font-style: italic;
  margin-left: 6px;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.label};
`;

export const EventCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 16px;
  padding: 0 5px;
  border-radius: 6px;
  background: ${(props) => props.theme.colors.red};
  color: ${(props) => props.theme.colors.white};
  font-size: 9px;
  font-weight: 800;
`;

export const Strip = styled.div`
  position: relative;
  width: 100%;
  height: 28px;
  border-radius: 6px;
  background: ${(props) =>
    props.theme.title === 'light'
      ? 'rgba(0, 0, 0, 0.04)'
      : 'rgba(255, 255, 255, 0.04)'};
  border: 1px solid ${(props) => props.theme.colors.disabled};
  overflow: hidden;
`;

export const Tick = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: ${(props) => props.$position}%;
  width: 1px;
  background: ${(props) => props.theme.colors.disabled};
  opacity: 0.5;
`;

export const Marker = styled.button`
  position: absolute;
  top: 50%;
  left: ${(props) => props.$position}%;
  transform: translate(-50%, -50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${(props) => props.$color};
  color: ${(props) => props.theme.colors.white};
  border: 2px solid ${(props) => props.theme.colors.card};
  cursor: pointer;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-family: inherit;
  transition: transform 150ms;
  z-index: 2;

  :hover {
    transform: translate(-50%, -50%) scale(1.15);
  }
`;

export const LoadingPlaceholder = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  color: ${(props) => props.theme.colors.label};
  font-style: italic;
`;

export const EmptyHint = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px;
  color: ${(props) => props.theme.colors.label};
  font-style: italic;
  opacity: 0.7;
`;

export const AxisLabels = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  color: ${(props) => props.theme.colors.label};
  font-variant-numeric: tabular-nums;
  padding: 0 2px;
`;
